var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor"}},[_c('path',{attrs:{"d":"M10 20v-6h4v6h5v-8h3L12 3L2 12h3v8h5z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }